import React from 'react';
import { Typography, Stack } from '@mui/material';
import DatePicker from 'react-multi-date-picker';
import BuildingSelector from '../buildingselector/BuildingSelector';
import Admin from '../auth/Admin';
import OrganizationSelector from '../userMgmt/OrganizationSelector';
import BuildingMultiSelector from '../buildingselector/BuildingMultiSelector';

import './changelog-filter.css';

const ChangelogFilters = ({ filters, setFilters, noDates = false, singleBuilding = false }) => (
  <Stack direction="row">
    <Admin superAdmin>
      <div className="changelog-filter">
        <Typography variant="h6">Org:</Typography>
        <OrganizationSelector
          allowNulls
          selected={filters.orgId}
          onValueChange={(orgId) => setFilters({ ...filters, orgId, buildings: [] })}
        />
      </div>
    </Admin>
    <div className="changelog-filter">
      <Typography variant="h6">Building Selection:</Typography>
      {singleBuilding ? (
        <BuildingSelector
          selectedBuildingId={filters.buildings[0] ?? -1}
          orgId={filters.orgId}
          handleSelection={(e) => setFilters({ ...filters, buildings: [e.target.value] })}
        />
      ) : (
        <BuildingMultiSelector
          selected={filters.buildings}
          orgId={filters.orgId}
          onValueChange={(buildings) => setFilters({ ...filters, buildings })}
        />
      )}
    </div>
    {noDates ? null : (
      <div className="changelog-filter">
        <Typography variant="h6">Date Selection:</Typography>
        <DatePicker
          value={filters.date}
          maxDate={new Date()}
          onChange={(ts) => setFilters({ ...filters, date: new Date(ts) })}
        />
      </div>
    )}
  </Stack>
);

export default ChangelogFilters;
